import emptySplitApi from "../utils/rtk";
import { User, updateProfile } from "../types/User";
import { END_POINTS } from "../helpers";

type CommonResponseType = {
  data: any;
  status: number;
  message: string;
};

type CommonBody = {
  start: number;
  length: number;
  search: string;
};

export const dashboardApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardData: builder.mutation<CommonResponseType, {}>({
      query: ({}) => ({
        url: `${END_POINTS.dashboardData}`,
        method: "GET",
      }),
    }),
    postVendorGraph: builder.query<CommonResponseType, { interval: number }>({
      query: ({ interval }) => ({
        url: END_POINTS.vendorGraph,
        method: "POST",
        body: { interval },
      }),
    }),
    postOrderGraph: builder.query<CommonResponseType, { interval: number }>({
      query: ({ interval }) => ({
        url: END_POINTS.orderGraph,
        method: "POST",
        body: { interval },
      }),
    }),
    postProductGraph: builder.query<CommonResponseType, { interval: number }>({
      query: ({ interval }) => ({
        url: END_POINTS.productGraph,
        method: "POST",
        body: { interval },
      }),
    }),
    postUserGraph: builder.query<CommonResponseType, { interval: number }>({
      query: ({ interval }) => ({
        url: END_POINTS.userGraph,
        method: "POST",
        body: { interval },
      }),
    }),

    postRevenueGraph: builder.query<CommonResponseType, { interval: number }>({
      query: ({ interval }) => ({
        url: END_POINTS.revenueGraph,
        method: "POST",
        body: { interval },
      }),
    }),

    myNotifications: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.myNotifications,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetDashboardDataMutation,
  useLazyPostUserGraphQuery,
  useLazyPostVendorGraphQuery,
  useLazyPostOrderGraphQuery,
  useLazyPostProductGraphQuery,
  useLazyPostRevenueGraphQuery,
  useMyNotificationsMutation,
} = dashboardApi;
